import { createLucideIcon } from "lucide-react";

export const Stars = createLucideIcon(
    "Stars",
    [
        [
            "path",
            {
                d: "M1.33398 13.0002C1.88954 13.0002 3.00065 11.8891 3.00065 11.3335C3.00065 11.8891 4.11176 13.0002 4.66732 13.0002C4.11176 13.0002 3.00065 14.1113 3.00065 14.6668C3.00065 14.1113 1.88954 13.0002 1.33398 13.0002Z",
                key: "1rtpn0",
            },
        ],
        [
            "path",
            {
                d: "M10.666 3.3335C11.3327 3.3335 12.666 2.00016 12.666 1.3335C12.666 2.00016 13.9993 3.3335 14.666 3.3335C13.9993 3.3335 12.666 4.66683 12.666 5.3335C12.666 4.66683 11.3327 3.3335 10.666 3.3335Z",
                key: "1158hf",
            },
        ],
        [
            "path",
            {
                d: "M2 8C5 8 8 5 8 2C8 5 11 8 14 8C11 8 8 11 8 14C8 11 5 8 2 8Z",
                key: "k46i9z",
            },
        ],
    ],
);
